import React from 'react';
import { BG, HERO, LOGO_WHITE } from '../../assets/images';
import styles from './LeftPanel.module.css';

export default function LeftPanel() {
  return (
      <aside className={styles.panel}>
        {/* Background image layer */}
        <div className={styles.bg} style={{ backgroundImage: `url(${BG})` }} />
        {/* Gradient overlay */}
        <div className={styles.overlay} />

        {/* Content */}
        <div className={styles.content}>
          {/* Logo */}
          <div className={styles.logoWrap}>
            <img src={LOGO_WHITE} alt="Eu Quero Grana" className={styles.logo} />
          </div>

          {/* Center hero */}
          <div className={styles.hero}>


            <div className={styles.circleWrap}>
              <div className={styles.circleOuter} />
              <div className={styles.circleInner}>
                <img src={HERO} alt="Milene Pavoro" className={styles.heroImg} />
              </div>
            </div>

            <div className={styles.caption}>
              <h3>Empréstimo com débito<br />na Conta de Luz</h3>
              <p>A luz na sua saúde financeira</p>
            </div>

            {/* Stats strip */}
            <div className={styles.stats}>
              <div className={styles.stat}>
                <span className={styles.statNum}>100%</span>
                <span className={styles.statLabel}>Digital</span>
              </div>
              <div className={styles.statDivider} />
              <div className={styles.stat}>
                <span className={styles.statNum}>24h</span>
                <span className={styles.statLabel}>Análise</span>
              </div>
              <div className={styles.statDivider} />
              <div className={styles.stat}>
                <span className={styles.statNum}>Sem</span>
                <span className={styles.statLabel}>Burocracia</span>
              </div>
            </div>
          </div>

          {/* Footer secure badge */}
          <div className={styles.secure}>
            <svg width="14" height="15" viewBox="0 0 24 24" fill="none">
              <rect x="5" y="11" width="14" height="11" rx="2"
                    stroke="rgba(255,255,255,0.75)" strokeWidth="2" />
              <path d="M8 11V7a4 4 0 018 0v4"
                    stroke="rgba(255,255,255,0.75)" strokeWidth="2" strokeLinecap="round" />
            </svg>
            Você está em um ambiente seguro.
          </div>
        </div>
      </aside>
  );
}